var getRangePercent = function (value, minValue, maxValue) {
    if (minValue === void 0) { minValue = 0; }
    if (maxValue === void 0) { maxValue = 100; }
    var range = maxValue - minValue;
    var validValue = Math.min(maxValue, Math.max(minValue, value));
    var adjValue = validValue - minValue;
    return (adjValue / range) * 100;
};

export { getRangePercent };
//# sourceMappingURL=getRangePercent.js.map
